import { type TaxonomyApiType, type TaxonomyQueryType, videoService } from "../services/video-service.ts";

export const videoRepo = {
    getComments: async (page: number) => {
        return await videoService.getComments(page);
    },
    approveComment: async (commentId: number, is_review: 'true' | 'false') => {
        return await videoService.approveComment(commentId, is_review);
    },
    answerComment: async (commentId: number, answer: string) => {
        return await videoService.answerComment(commentId, answer);
    },
    deleteComment: async (commentId: number) => {
        return await videoService.deleteComment(commentId);
    },
    getMovies: async (page: number, search?: string) => {
        return await videoService.getMovies(page, search);
    },
    getMovie: async (id: number) => {
        return await videoService.getMovie(id);
    },
    updateMovie: async (id: number, payload: Parameters<typeof videoService.updateMovie>[1]) => {
        return await videoService.updateMovie(id, payload);
    },
    deleteMovie: async (id: number) => {
        return await videoService.deleteMovie(id);
    },
    searchTaxonomies: async (query: string, type: TaxonomyQueryType) => {
        return await videoService.searchTaxonomies(query, type);
    },
    getTaxonomies: async (type: TaxonomyApiType, page: number, search?: string) => {
        return await videoService.getTaxonomies(type, page, search);
    },
    getTaxonomy: async (type: TaxonomyApiType, id: number) => {
        return await videoService.getTaxonomy(type, id);
    },
    updateTaxonomy: async (type: TaxonomyApiType, id: number, name: string, slug: string, image?: File | null) => {
        return await videoService.updateTaxonomy(type, id, name, slug, image);
    },
    deleteTaxonomy: async (type: TaxonomyApiType, id: number) => {
        return await videoService.deleteTaxonomy(type, id);
    },
};